import React from 'react';

import i18n from 'util/i18n';
import { CITIZENSHIP } from 'config/formSections/citizenship';

import SectionIntro from 'components/Section/shared/SectionIntro';
import { isPVQForm } from 'helpers/form';

const Intro = function (props) {
  const isPVQ = isPVQForm(props.formType);
  const pvq = isPVQ ? '.pvq' : '';
  return (
    <SectionIntro
      title={i18n.t(`citizenship${pvq}.intro.title`)}
      body={i18n.m(`citizenship${pvq}.intro.body`)}
      sectionKey={CITIZENSHIP.key}
    />
  );
};

export default Intro;
